// src/routes/RequireAdmin.js
import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import apiClient from '../utils/axiosInstance';

function RequireAdmin({ children }) {
  const [authState, setAuthState] = useState('loading'); // 'loading' | 'authenticated' | 'unauthenticated'

  useEffect(() => {
    let cancelled = false;

    const checkAuth = async () => {
      try {
        const res = await apiClient.get('/auth/me');
        if (!cancelled && res.data?.user) {
          setAuthState('authenticated');
        } else {
          setAuthState('unauthenticated');
        }
      } catch {
        if (!cancelled) {
          setAuthState('unauthenticated');
        }
      }
    };

    checkAuth();
    return () => { cancelled = true; };
  }, []);

  if (authState === 'loading') {
    return null; // 또는 로딩 스피너
  }

  if (authState === 'unauthenticated') {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}

export default RequireAdmin;
